import { useEffect, useState } from "react"
import { getSurrender, getUserWithoutDetail, sendCypherCode, sendStartCode } from "../../api"
import { AdminAlert, Code, Cypher, Heading, Helps, Loading, PDFDownload, Section, Start } from "../../components"
import { useAction, useAppState } from "../../hooks"
import { GAMES, gameType, removeWindowSearch } from "../../utils"
import { EInfoMessageType, TCypher, TUser } from "../../types"

import './websystem.scss'

type WebsystemProps = {
    inputCode: string,
    setInputCode: any,
    startCode: string,
    setStartCode: any,
    setLoginModalVisible: any
}

export const Websystem = ({ inputCode, setInputCode, startCode, setStartCode, setLoginModalVisible }: WebsystemProps) => {

    const { state } = useAppState()
    const [user, setUser] = useState<TUser | undefined>(undefined)
    const [loading, setLoading] = useState(false)
    const [selectedAction, setSelectedAction] = useState('CYPHER')
    const { setInfoMessageAction } = useAction()
    const [surrendedMessage, setSurrendedMessage] = useState('')


    useEffect(() => {
        if (state?.token && inputCode.length > 0) {
            sendCypherCode({ code: inputCode, token: state.token }).then((res) => {
                console.log(res)
                if (res.sucessMessage) {
                    setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.sucessMessage, timeout: 60 })
                    refreshUser()
                } else if (res.errorMessage) {
                    console.log('ERROR')
                    console.log(res.errorMessage)
                    setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                    setLoading(false)
                }
            })
            setInputCode('')
            removeWindowSearch()
        }
    }, [inputCode, state])

    useEffect(() => {
        if (state?.token && startCode.length > 0) {
            sendStartCode({ code: startCode, token: state.token }).then((res) => {
                console.log(res)
                if (res.sucessMessage) {
                    setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.sucessMessage, timeout: 60 })
                    refreshUser()
                } else if (res.errorMessage) {
                    console.log('ERROR')
                    console.log(res.errorMessage)
                    setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                    setLoading(false)
                }
            })
            setStartCode('')
            removeWindowSearch()
        }
    }, [startCode, state])

    useEffect(() => {
        if (state?.token && user?.GameInfo?.Status === 5) {
            getSurrender({ token: state?.token }).then(res => {
                if (res.message) {
                    setSurrendedMessage(res.message)
                }
            })
        }
    }, [user])

    useEffect(() => {
        refreshUser()
    }, [state?.token])

    const refreshUser = () => {
        setLoading(true)
        if (state?.token) {
            getUserWithoutDetail({ token: state.token }).then((response) => {
                if (response.user) {
                    setUser(response.user)
                }
            })
        } else {
            setUser(undefined)
        }
        setLoading(false)
    }

    if (loading) {
        return <Loading />
    }

    if (!user) {
        return (
            <Section centered={ true}>
                <button className='button' onClick={() => setLoginModalVisible(true)}>Přihlásit se</button>
            </Section>
            )
    }

    if ((user?.GameInfo?.cypher == undefined) || (user.GameInfo.cypher < 0)) {
        return <>
            <AdminAlert message={user?.GameInfo?.message} />
            <Start refreshUser={refreshUser} setLoading={setLoading} />
        </>
    }
     
    return (
        <>
            <AdminAlert message={user.GameInfo.message} />
            {user.GameInfo.Status === 5 ? <AdminAlert message={surrendedMessage} /> : <></> }

            {
                gameType() === GAMES.ZKRATKA ? (
                    <Section>
                        <div className='gameInfo'>
                            <div>Celkem bodů: {user.GameInfo.points}</div>
                        </div>
                    </Section>
                ) : ''
            }

            <Code setLoading={setLoading} refreshUser={refreshUser} selectedAction={selectedAction} setSelectedAction={setSelectedAction } />

            <Cypher user={user} refreshUser={ refreshUser} />
        </>
    )
}

export default Websystem